import React, { useState } from "react";
import { FaCirclePlus } from "react-icons/fa6";
import { Line, LineChart, ResponsiveContainer} from "recharts";

const LiveRateTable = () => {
  const [isLive, setIsLive] = useState(true);
  const generateRandomData = (baseValue, fluctuationRange, length) => {
    return Array.from({ length }, (_, i) => ({
      value:
        baseValue + (Math.random() * fluctuationRange * 2 - fluctuationRange),
    }));
  };
  const rates = [
    {
      currency: "USD",
      flag: "https://flagcdn.com/w40/us.png",
      amount: 1,
      change: 0.5,
      data: generateRandomData(1, 0.5, 12),
    },
    {
      currency: "EUR",
      flag: "https://flagcdn.com/w40/eu.png",
      amount: 0.92,
      change: -0.2,
      data: generateRandomData(0.92, 1, 12),
    },
    {
      currency: "GBP",
      flag: "https://flagcdn.com/w40/gb.png",
      amount: 0.79,
      change: 0.016,
      data: generateRandomData(0.79, 3, 12),
    },
    {
      currency: "JPY",
      flag: "https://flagcdn.com/w40/jp.png",
      amount: 151.83,
      change: 0.25,
      data: generateRandomData(151.83,100, 12),
    },
    {
      currency: "CAD",
      flag: "https://flagcdn.com/w40/ca.png",
      amount: 1.42,
      change: 0.1,
      data: generateRandomData(1.42, 6, 12),
    },
  ];

  return (
    <div className="p-6 mx-auto max-w-full mt-5">
      <div className="overflow-x-auto scrollbar scrollbar-thick scrollbar-thumb-black scrollbar-track-gray-800">
        <table className="w-full table-auto min-w-[600px]">
          <thead>
            <tr className="text-left border-b border-gray-200">
              <th className="pb-3 text-sm font-medium text-gray-500 w-1/4 whitespace-nowrap">
                Inverse{" "}
                <button
                  onClick={() => setIsLive(!isLive)}
                  className={`relative w-12 h-6 rounded-full p-1 transition-colors duration-200 ${
                    isLive ? "bg-blue-500" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-200 ${
                      isLive ? "translate-x-6" : "translate-x-0"
                    }`}
                  />
                </button>
              </th>
              <th className="pb-3 text-sm font-medium text-gray-500 w-1/4">
                Amount
              </th>
              <th className="pb-3 text-sm font-medium text-gray-500 w-1/4">
                Change (24h)
              </th>
              <th className="pb-3 text-sm font-medium text-gray-500 w-1/4">
                Chart (24h)
              </th>
            </tr>
          </thead>
          <tbody>
            {rates.map((rate, index) => (
              <tr
                key={index}
                className={`transition-colors group rounded-tl-md rounded-bl-md items-center ${
                  index % 2 !== 0 ? "bg-gray-100" : ""
                }`}
              >
                <td className="py-4 ps-2 ">
                  <div className="flex items-center">
                    {" "}
                    <img
                      src={rate?.flag}
                      alt={rate?.currency}
                      className="w-6 h-6 mr-3 rounded-full"
                    />
                    <span className="text-sm font-medium text-black">
                      {rate?.currency}
                    </span>
                  </div>
                </td>
                <td className="py-2 text-sm text-black ">{rate?.amount}</td>
                <td className="py-2 text-sm">
                  <span
                    className={`p-1 px-2 rounded-primary ${
                      rate?.change >= 0
                        ? "bg-[#cdf0db] text-green-700"
                        : "bg-[#eecbcb]  text-red-600"
                    }`}
                  >
                    {rate?.change}%
                  </span>
                </td>
                <td className="py-2 text-sm text-black">
                  <ResponsiveContainer width="100%" height={80}>
                    <LineChart
                      data={rate.data}
                      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#00C853"
                        strokeWidth={2}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between pt-4 gap-4">
        <button className="rounded-secondary bg-primary py-2 px-4 flex items-center gap-2 text-white group-hover:bg-black">
          <FaCirclePlus /> Add currency
        </button>
        <div className="mt-2 sm:mt-0 text-xs text-gray-400 whitespace-nowrap">
          Last updated Feb 18, 2025, 12:42 UTC
        </div>
      </div>
    </div>
  );
};

export default LiveRateTable;
